import React, {Component} from 'react';
import './Logo.css';
import {ajax} from '../../../Context';

class Logo extends Component {
    render() {

        if (this.props.url !== undefined) {
            let imagepath = ajax.url + this.props.url;
            return (
                <img className="logo-img" alt="Logo" src={imagepath}/>
            )
        }
        return null
    }
}

export default Logo;


// WEBPACK FOOTER //
// ./src/Components/Elements/Logo/Logo.js